export const environment = {
  production: false,
  apiUrl: 'https://saas.api.dev.softion.io/api/v1',
  storefrontUrl: 'http://localhost:4302',
  storefrontDomain: 'localhost',
  storefrontSlugSuffix: '',
  //storefrontUrl: 'https://qa-webly-saas.pages.dev/',
  logoFull: 'MARCA-OFICIAL.png',
  logoSmall: 'STICKER_small.png',
  // storageUrl: 'http://localhost:8882/api/v1',
  storageUrl: 'https://storage.api.dev.softion.io/api/v1',
  storageSignature: '5i4m.un/Am6KvuSB.EmQ.5Up1stC@MnwNfr/iGIx40LjV148rwRAriHug-IIs7xhXBpecah&HLbOjz|g',
};
